import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html, nothing } from "lit";
import { iconClasses, rowItemClasses, wrapperClasses, buttonClasses } from "./utils.js";
import "../../atom/Icon/index.js";
import "../../atom/Text/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfAccordion = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_open = false;
    this.dsf_custom_header = false;
    this.dsf_borderless = false;
    this.dsf_size = "medium";
  }
  renderHeader() {
    if (this.dsf_custom_header) {
      return html`
        <slot name="custom-header"></slot>
        <dsf-icon dsf_name="ChevronDown" class=${iconClasses(this)}></dsf-icon>
      `;
    }
    return html`
      <div class=${rowItemClasses}>
        <slot name="icon"></slot>
        <dsf-text data-title dsf_level="s-semibold">${this.dsf_title}</dsf-text>
        <slot name="badge"></slot>
      </div>
      <div class=${rowItemClasses}>
        <slot name="link"></slot>
        <dsf-icon dsf_name="ChevronDown" class=${iconClasses(this)}></dsf-icon>
      </div>
    `;
  }
  renderContent() {
    if (this.dsf_open) {
      return html`
        <div class="mt-1 p-12 pt-0">
          <slot name="content"></slot>
        </div>
      `;
    }
    return nothing;
  }
  onButtonClick() {
    this.dsf_open = !this.dsf_open;
    this.emit(this.dsf_open ? "open" : "close");
  }
  render() {
    return html`
      <div class=${wrapperClasses(this)}>
        <button type="button" class=${buttonClasses(this)} @click=${this.onButtonClick} data-button>
          ${this.renderHeader()}
        </button>
        ${this.renderContent()}
      </div>
    `;
  }
};
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfAccordion.prototype, "dsf_open", 2);
__decorateClass([
  prop({ type: String })
], DsfAccordion.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfAccordion.prototype, "dsf_custom_header", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfAccordion.prototype, "dsf_borderless", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfAccordion.prototype, "dsf_size", 2);
DsfAccordion = __decorateClass([
  defineElement("dsf-accordion")
], DsfAccordion);
export {
  DsfAccordion
};
